import Vue from "vue";
import {
  Icon,
  Tab,
  Tabs,
  List,
  Cell,
  Button,
  Popup,
  Field,
  Dialog,
  Toast,
  Swipe,
  SwipeItem,
  Area,
  NavBar,
  CellGroup,
  Image,
  Sticky,
  Collapse,
  CollapseItem,
  Steps,
  Step,
  Skeleton,
  RadioGroup,
  Radio,
  Progress,
  Row,
  Col,
  CheckboxGroup,
  Checkbox,
  Badge,
  PullRefresh,
  Empty,
  Uploader,
  Loading
} from "vant";

Vue.use(Icon);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(List);
Vue.use(Cell);
Vue.use(Button);
Vue.use(Popup);
Vue.use(Field);
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Area);
Vue.use(NavBar);
Vue.use(CellGroup);
Vue.use(Image);
Vue.use(Sticky);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Skeleton);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Progress);
Vue.use(Row);
Vue.use(Col);
Vue.use(CheckboxGroup);
Vue.use(Checkbox);
Vue.use(Badge); 
Vue.use(PullRefresh);
Vue.use(Empty);
Vue.use(Uploader);
Vue.use(Loading);
